/**
 * VehicleSection.tsx
 * 予約コード, 車両コード, 車種
 * ※貸出場所・返却場所は非表示（将来開発予定）
 */
import React, { useMemo } from 'react';
import { SectionProps } from '../types';
import SectionHeader from '../shared/SectionHeader';
import FieldDisplay from '../shared/FieldDisplay';

interface VehicleSectionProps extends SectionProps {
  vehicles?: any[] | Record<string, any>;
  vehicleTypes?: any[];
  onAssignClick?: (data?: any) => void;
}

export default function VehicleSection({
  data,
  onChange,
  disabled,
  onOpenEdit,
  vehicles,
  vehicleTypes = [],
  onAssignClick,
}: VehicleSectionProps) {
  const vehicleCode = useMemo(() => {
    const vid = data.vehicle_id;
    if (!vid || !vehicles) return data.vehicle_code || '';
    let vehicle: any = null;
    if (Array.isArray(vehicles)) {
      vehicle = vehicles.find(
        (v) => String(v.id) === String(vid) || String(v.resource_id) === String(vid),
      );
    } else if (typeof vehicles === 'object') {
      vehicle = (vehicles as Record<string, any>)[vid];
    }
    return vehicle?.vehicle_code || data.vehicle_code || '';
  }, [data.vehicle_id, data.vehicle_code, vehicles]);

  const formattedType = useMemo(() => {
    if (!data.car_type) return '';
    if (!Array.isArray(vehicleTypes)) return data.car_type;
    const match = vehicleTypes.find(
      (vt) => vt.vehicle_type_code === data.car_type || vt.code === data.car_type,
    );
    if (match) {
      return `${match.vehicle_type_code || match.code} (${match.vehicle_type_name || match.name})`;
    }
    return data.car_type;
  }, [data.car_type, vehicleTypes]);

  const typeOptions = useMemo(
    () =>
      (vehicleTypes || []).map((vt: any) => ({
        label: `${vt.vehicle_type_code || vt.code} (${vt.vehicle_type_name || vt.name})`,
        value: vt.vehicle_type_code || vt.code,
      })),
    [vehicleTypes],
  );

  return (
    <>
      <SectionHeader title="車両" />
      <div className="gc-field">
        <label className="gc-label" style={{ fontSize: '0.85rem', color: '#64748b' }}>
          車両コード
        </label>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {onAssignClick && (
            <button
              type="button"
              onClick={() => onAssignClick(data)}
              disabled={disabled}
              style={{
                padding: '4px 12px',
                fontSize: '0.75rem',
                fontWeight: 600,
                border: 'none',
                borderRadius: 6,
                cursor: disabled ? 'default' : 'pointer',
                background: '#1976d2',
                color: '#fff',
                height: 34,
                whiteSpace: 'nowrap',
              }}
            >
              アサイン
            </button>
          )}
          <div
            className="gc-input"
            style={{
              background: '#f8fafc',
              border: '1px solid #e2e8f0',
              borderRadius: 4,
              padding: '8px 12px',
              minHeight: 38,
              display: 'flex',
              alignItems: 'center',
              color: '#334155',
              flex: 1,
            }}
          >
            {vehicleCode || '-'}
          </div>
        </div>
      </div>
      <FieldDisplay
        label="予約車両タイプ"
        value={formattedType}
        onClick={() => onOpenEdit?.('car_type', '車種', 'select', typeOptions)}
      />
      {/* 貸出場所・返却場所は将来開発予定のため非表示 */}
    </>
  );
}
